import 'es6-promise/auto';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import { router } from './vuerouter.js'
import { store } from './vuexstore.js'
import { i18n } from './i18n.js'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './custom.scss'
import Vuelidate from 'vuelidate'
import UUID from 'vue-uuid';

import 'vue-search-select/dist/VueSearchSelect.css'

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect);

library.add(faTimesCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(UUID);
Vue.use(Vuelidate);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')

